import React, {useEffect, useMemo} from 'react'
import {InputText} from 'primereact'
import {useState} from 'react'
import {
  createOrUpdateGateway,
  fetchAllSites,
  fetchGatewayModes,
  fetchGatewayTypes,
  getAllSite,
  getGatewayModes,
  getGatewayTypes,
  getSelectedGateway,
  setSelectedGateway,
} from '../../../slice/gateway.slice'
import {setToastParams} from '../../../../../store/slices/ui.slice'
import {InputSwitch} from 'primereact/inputswitch'
import {Dropdown} from 'primereact/dropdown'
import ButtonComponent from '../../../../shared/ButtonComponent'
import {useNavigate} from 'react-router-dom'
import {useAppDispatch, useAppSelector} from '../../../../../hooks'
import _ from 'lodash'
import {centroid} from '@turf/turf'
import {Card} from 'primereact/card'
import {OlangItem} from '../../../../shared/Olang/user-interface/OlangItem/OlangItem'
import GatewayGeofence from '../../GatewayGeofence/GatewayGeofence'
import { PageHeader } from '../../../../shared/PageHeader/PageHeader'

const GatewayEditor = (props) => {
  const [inputs, setInputs] = useState({active: true})
  const [isValid, setIsValid] = useState(false)
  const [selectedSite, setSelectedSite] = useState(null)
  const [worksiteOptions, setWorksiteOptions] = useState([])
  const [exitMarkerPosition, setExitMarkerPosition] = useState([0, 0])
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const selectedGateway = useAppSelector(getSelectedGateway)
  const worksites = useAppSelector(getAllSite)
  const gatewayTypes = useAppSelector(getGatewayTypes)
  const gatewayModes = useAppSelector(getGatewayModes)

  const [roles] = useState([
    {label: 'Administrateur', value: 'admin'},
    {label: 'Utilisateur', value: 'user'},
  ])
  const dispatch = useAppDispatch()
  const onHide = () => {
    typeof props.onHide == 'function' && props.onHide()
    dispatch(setSelectedGateway(null))
  }

  const validateInputs = (data) => {
    const newErrors = {}
    
    // Validation des champs obligatoires
    if (!data.label || data.label.trim() === '') {
      newErrors.label = 'IMEI est requis'
    }
    
    if (!data.code || data.code.trim() === '') {
      newErrors.code = 'Code est requis'
    }
    
    if (!data.locationId) {
      newErrors.locationId = 'Site est requis'
    }
    
    if (!data.mode) {
      newErrors.mode = 'Mode est requis'
    }
    
    if (!data.srcObject) {
      newErrors.srcObject = 'Type est requis'
    }
    
    // Validation des mots de passe seulement s'ils sont présents
    if (data.pwd || data.confPassword) {
      if (data.pwd && data.confPassword && data.pwd !== data.confPassword) {
        newErrors.confPassword = 'Les mots de passe ne correspondent pas'
      }
    }
    
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const onInputChange = (e) => {
    const newInputs = {...inputs, [e.target.name]: e.target.value}
    setInputs(newInputs)
    
    // Effacer l'erreur pour ce champ
    if (errors[e.target.name]) {
      setErrors(prev => {
        const newErrors = {...prev}
        delete newErrors[e.target.name]
        return newErrors
      })
    }
    
    // Valider et mettre à jour isValid
    const isValidForm = validateInputs(newInputs)
    setIsValid(isValidForm)
    
    if (e.target.name === 'locationId' && e.target.value && Array.isArray(worksites)) {
      const findSite = worksites.find((site) => site.id == e.target.value)
      setSelectedSite(findSite)
    }
  }

  useEffect(() => {
    const newInputs = selectedGateway?.label ? selectedGateway : {active: true, srcObject: 'GATEWAY'}
    setInputs(newInputs)
    
    // Valider les données initiales
    const isValidForm = validateInputs(newInputs)
    setIsValid(isValidForm)
  }, [selectedGateway])

  useEffect(() => {
    // Cette logique de validation est maintenant gérée par validateInputs()
    console.log('data:', inputs)
  }, [inputs])

  const save = async () => {
    // Valider avant de sauvegarder
    if (!validateInputs(inputs)) {
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR DE VALIDATION',
          detail: 'Veuillez corriger les erreurs dans le formulaire',
        })
      )
      return
    }

    setIsLoading(true)
    let data = _.cloneDeep(inputs)
    console.log('dataaaaaa log:', data)
    
    if (data?.active === undefined) data.active = 1
    
    try {
      let res = await dispatch(createOrUpdateGateway({data, exitLatLng: exitMarkerPosition}))
      
      let result = res?.payload?.result?.[0]
      if (!res.payload?.success || result?.typeMsg == 'error') {
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: result?.errorMsg || 'Opération échouée. Veuillez réessayer !',
          })
        )
      } else {
        dispatch(
          setToastParams({
            show: true,
            severity: 'success',
            summary: 'SUCCÈS',
            detail: inputs.id ? 'Gateway modifié avec succès' : 'Gateway créé avec succès',
          })
        )
        typeof props.onSave == 'function' && props.onSave()
        onHide()
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Une erreur inattendue est survenue',
        })
      )
    } finally {
      setIsLoading(false)
    }
  }

  const onAddress = (address) => {
    if (address?.lat && address?.lng) {
      setInputs((prev) => ({
        ...prev,
        lat: address?.lat.toString(),
        lng: address?.lng.toString(),
        address: address?.formatted_address,
      }))
    }
  }

  useEffect(() => {
    if (inputs?.worksite) {
      let detail = worksites.find((o) => o.id == inputs?.worksite)
      // Deposit data uses relationId instead of geofence
      if (detail?.relationId && detail?.relationId !== '0') {
        // TODO: Fetch geofence data using relationId if needed
        console.log('Deposit relationId:', detail.relationId)
      }
    }
  }, [inputs?.worksite, worksites])

  useEffect(() => {
    if (Array.isArray(worksites)) {
      console.log('worksites:', worksites)
      setWorksiteOptions(
        worksites.map((o) => ({label: o.label, value: o.id, icon: o?.activeColor || 'green'}))
      )
    }
  }, [worksites])

  useEffect(() => {
    dispatch(fetchAllSites())
    dispatch(fetchGatewayTypes())
    dispatch(fetchGatewayModes())

    // return () => {
    //   dispatch(setSelectedGateway(null))
    // }
  }, [])

  return (
    <>
      {/* Page Header */}
      {/* <PageHeader
        title={inputs?.id ? 'gateway.edit' : 'gateway.new'}
        onBack={onHide}
        info={
          <div className="flex align-items-center gap-2">
            <i className="pi pi-wifi text-xl text-primary"></i>
            <span className="text-lg font-semibold">
              {inputs?.label || 'Nouveau Gateway'}
            </span>
          </div>
        }
        className="m-3"
      /> */}
      
      <div className='flex w-full flex-column gap-3 lg:flex-row xl:flex-row  justify-content-between bg-white p-2'>
        <Card className='p-2 w-full md:w-9 lg:w-9 xl:w-6 shadow-2 bg-white'>
        <div className='flex flex-column my-4'>
          <div className='mt-5'>
            <label htmlFor='title' className='w-3  text-right'>
              <OlangItem olang='code' />
            </label>
            <InputText
              name='code'
              required={true}
              value={inputs.code}
              onChange={onInputChange}
              className={`w-9 ${errors.code ? 'p-invalid' : ''}`}
            />
            {errors.code && <small className="p-error block mt-1">{errors.code}</small>}
          </div>
          <div className='my-4 mt-5 flex gap-2 align-items-center'>
            <label htmlFor='title' className='w-3  text-right'>
              IMEI
            </label>
            <div className="flex flex-column w-9">
              <InputText
                name='label'
                required={true}
                value={inputs.label}
                onChange={onInputChange}
                className={`w-full ${errors.label ? 'p-invalid' : ''}`}
              />
              {errors.label && <small className="p-error block mt-1">{errors.label}</small>}
            </div>
          </div>
          <div className='my-4 mt-5 flex gap-2 align-items-center'>
            <label htmlFor='title' className='w-3  text-right'>
              <OlangItem olang='type' />
            </label>
            <div className="flex flex-column w-9">
              <Dropdown
                name='srcObject'
                value={inputs.srcObject}
                className={`w-full ${errors.srcObject ? 'p-invalid' : ''}`}
                filter
                onChange={onInputChange}
                optionValue='name'
                optionLabel='label'
                options={gatewayTypes}
              />
              {errors.srcObject && <small className="p-error block mt-1">{errors.srcObject}</small>}
            </div>
          </div>

          <div className='my-4 mt-5 flex gap-2 align-items-center'>
            <label htmlFor='title' className='w-3  text-right'>
              <OlangItem olang='mode' />
            </label>
            <div className="flex flex-column w-9">
              <Dropdown
                name='mode'
                value={inputs.mode}
                className={`w-full ${errors.mode ? 'p-invalid' : ''}`}
                filter
                onChange={onInputChange}
                optionValue='name'
                optionLabel='label'
                options={gatewayModes}
              />
              {errors.mode && <small className="p-error block mt-1">{errors.mode}</small>}
            </div>
          </div>
         
          <div className='my-4 mt-5 flex gap-2 align-items-center'>
            <label htmlFor='title' className='w-3  text-right'>
              <OlangItem olang='site' />
            </label>
            <div className="flex flex-column w-9">
              <Dropdown
                name='locationId'
                value={inputs.locationId}
                className={`w-full ${errors.locationId ? 'p-invalid' : ''}`}
                // disabled={inputs?.id}
                filter
                // optionValue='value'
                // optionLabel='label'
                onChange={onInputChange}
                itemTemplate={(dt) => (
                  <div className='flex align-items-center' style={{gap: 10}}>
                    <span
                      className={`fas fa-duotone ${dt?.icon} text-blue-300`}
                      style={{fontSize: '30px'}}
                    ></span>
                    <strong>{dt.label}</strong>
                  </div>
                )}
                options={worksiteOptions}
              />
              {errors.locationId && <small className="p-error block mt-1">{errors.locationId}</small>}
            </div>
          </div>
          <div className='my-4  flex gap-2 align-items-center'>
            <label htmlFor='Roles' className='w-3  text-right'>
              <OlangItem olang='active' />
            </label>
            <InputSwitch
              name='active'
              checked={inputs.active == 1}
              onChange={(e) => setInputs((prev) => ({...prev, active: e.value ? 1 : 0}))}
            />
          </div>

        </div>
        <div className='flex gap-3 justify-content-end'>
          <ButtonComponent
            onClick={onHide}
            label={<OlangItem olang='cancel' />}
            className='p-button-danger'
            icon='pi pi-times'
            disabled={isLoading}
          />
          <ButtonComponent
            label={<OlangItem olang='save' />}
            disabled={!isValid || isLoading}
            onClick={save}
            icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            loading={isLoading}
          />
        </div>
      </Card>
      <Card className='p-2 w-full md:w-9 lg:w-9 xl:w-6 shadow-2 bg-white'>
        <GatewayGeofence
          exitMarkerPosition={exitMarkerPosition}
          setExitMarkerPosition={setExitMarkerPosition}
          selectedSite={selectedSite}
          setIsValid={setIsValid}
        />
      </Card>
      </div>
    </>
  )
}

export default GatewayEditor
